// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TagSelector-cls1___0bf92c8aad15452ea65{/*!*/}.TagSelector-cls2___f291be89b259f822099{--size: 40px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "TagSelector-cls1___0bf92c8aad15452ea65",
	"cls2": "TagSelector-cls2___f291be89b259f822099 TagSelector-cls1___0bf92c8aad15452ea65"
};
export default ___CSS_LOADER_EXPORT___;
